export const de = {
    translation: {
        app: {
            header: {
                switchTenant: 'Mandant wechseln',
            },
            navigationBar: {
                settings: 'Mandanteneinstellungen',
                switch: 'Mandant wechseln',
                aiAssistant: 'KI-Assistent',
            },
            user: {
                myProfile: 'Meine Kontoeinstellungen',
                logout: 'Abmelden',
            },
            applications: {
                root: {
                    name: 'Mandant verwalten',
                    description: 'Startseite und Einstellungen Ihrer Mandanten',
                },
            },
        },
        components: {
            noAccountingPlanAccess: 'Sie haben keinen Zugriff auf den Buchungsplan',
            noCostCentersAccess: 'Sie haben keinen Zugriff auf die Kostenstellen',
            advancedFormEditor: {
                textFormatPrompt: 'Eingabetyp festlegen',
                survey: {
                    ed: {
                        designer: 'Formular',
                    },
                },
                dialog: {
                    saveFail: {
                        title: 'Formular konnte nicht gespeichert werden',
                        message:
                            'Beim Speichern des Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
                    },
                },
            },
            importer: {
                importAction_zero: 'Nichts zu importieren',
                importAction_one: '{{count, number}} Zeile jetzt importieren',
                importAction_other: '{{count, number}} Zeilen jetzt importieren',
                parseData: {
                    parseError: 'Die Datei konnte nicht korrekt analysiert werden',
                    emptyError: {
                        title: 'Keine Daten',
                        message: 'Die Datei enthielt keine Daten/Informationen',
                    },
                    tooManyRows: {
                        title: 'Zu viele Zeilen',
                        message: 'Die Datei enthält mehr als die erlaubten {{maxRows, number}} Zeilen',
                    },
                },
                upload: {
                    uploadTitle: 'Datei wird analysiert',
                    format: 'CSV',
                },
                map: {
                    column: 'Spalte #{{column}}',
                    errors: {
                        required: 'Ein Wert ist erforderlich',
                        invalidDate: 'Ungültiges Datum "{{date}}"',
                        invalidNumber: 'Ungültige Nummer "{{number}}"',
                        invalidBoolean: 'Ungültiger Wert "{{boolean}}"',
                    },
                    toolbar: {
                        totalRows_one: '{{count, number}} Zeile',
                        totalRows_other: '{{count, number}} Zeilen',
                        importableRows: '{{count, number}} sind importierbar',
                        errorRows: '{{count, number}} Zeilen mit Fehler',
                        hasHeaderRow: 'Kopfzeile',
                        hiddenColumns_zero: 'Alle Spalten anzeigen',
                        hiddenColumns_one: 'Eine versteckte Spalte',
                        hiddenColumns_other: '{{count, number}} versteckte Spalten',
                        requiredColumns_one: 'Eine erforderliche Spalte',
                        requiredColumns_other: '{{count, number}} erforderliche Spalten',
                        requiredColumnsMessage: 'Die folgenden Spalten müssen zugewiesen werden:',
                        showErrorRowsOnly: 'Nur Fehlerzeilen anzeigen',
                        showErrorColumnsOnly: 'Nur Spalten anzeigen welche Fehler enthalten',
                    },
                    table: {
                        noMapping: 'Keine Zuweisung',
                        mapPlaceholder: 'Zuweisen',
                        errorsCount_none: 'Es wurden keine Zeilen mit Fehlern gefunden',
                        errorsCount_one: 'Es wurde eine Zeile mit Fehlern gefunden',
                        errorsCount_other: '{{count,number}} Zeilen mit Fehlern',
                        editPrompt: {
                            title: 'Wert bearbeiten',
                            prompt: 'Geben Sie einen neuen Wert ein',
                        },
                    },
                },
                importing: {
                    process: {
                        title_one: 'Eine Zeile wird importiert...',
                        title_other: '{{count, number}} Zeilen werden importiert...',
                        hint: 'Ihre Daten werden importiert. Bitte schließen Sie das Browserfenster nicht und warten Sie, bis der Vorgang abgeschlossen ist.',
                    },
                    results: {
                        title: 'Import abgeschlossen',
                        inserted_zero: 'Es wurde nichts importiert',
                        inserted_one: 'Eine Änderung wurde importiert',
                        inserted_other: '{{count, number}} Änderungen wurden importiert',
                        duplicates_zero: 'Keine Duplikate',
                        duplicates_one: 'Es wurde ein Duplikat ignoriert',
                        duplicates_other: '{{count, number}} Duplikate wurden ignoriert',
                        removed_zero: 'Es wurde nichts entfernt',
                        removed_other: '{{count, number}} Daten wurden entfernt',
                        updated_zero: 'Es wurden keine Daten aktualisiert',
                        updated_other: '{{count, number}} Daten wurden aktualisiert',
                        failed_zero: 'Kein Importvorgang ist fehlgeschlagen',
                        failed_other: 'Der Import von {{count, number}} Daten ist fehlgeschlagen',
                    },
                },
            },
            tagsFilterDropdown: {
                allTags: 'Alle',
                searchPlaceholder: 'Tag suchen',
                noTagsChosen: 'Keine Tags ausgewählt',
            },
            pagination: {
                previousPage: 'Vorherige Seite',
                nextPage: 'Nächste Seite',
                show: 'Zeige {{fromCount, int}} bis {{toCount, int}}',
                total: 'von {{count, int}} insgesamt',
            },
            page: {
                toolbar: {
                    responsiveTitle: 'Aktionen und Einstellungen',
                },
            },
            rruleEditor: {
                repeats: 'Wiederholung',
                options: {
                    daily: 'Jeden Tag',
                    weekly: 'Jede Woche',
                    monthly: 'Jeden Monat',
                    yearly: 'Jedes Jahr',
                    custom: 'Benutzerdefiniert',
                },
                every: 'Alle',
                frequency: 'Frequenz',
                frequencies: {
                    daily: 'Tag(e)',
                    weekly: 'Woche(n)',
                    monthly: 'Monat(e)',
                    yearly: 'Jahr(e)',
                },
                onEach: 'An jedem',
                onDay: 'Am',
                onThe: 'An jedem',
                advanced: {
                    positions: {
                        first: 'Erster',
                        second: 'Zweiter',
                        third: 'Dritter',
                        fourth: 'Vierter',
                        last: 'Letzter',
                    },
                    options: {
                        day: 'Tag',
                        week: 'Wochentag',
                        weekend: 'Wochenende',
                    },
                },
                until: {
                    label: 'Endet',
                    after: 'Nach',
                    times: 'Mal',
                    onDate: 'Am Datum',
                    none: 'Niemals',
                },
            },
            conditionGroupEditor: {
                editConditionGroup: 'Bedingungen bearbeiten',
                addCondition: 'Neue Bedingung hinzufügen',
                addGroup: 'Gruppe hinzufügen',
                matchAll: 'Alle müssen zutreffen',
                matchAny: 'Mindestens eine muss zutreffen',
                comparatorFunction: {
                    eq: 'Ist gleich',
                    isSet: 'Hat einen Wert',
                    lt: 'Ist kleiner als',
                    lte: 'Ist kleiner oder gleich',
                    gt: 'Ist größer als',
                    gte: 'Ist größer oder gleich',
                    includes: 'Enthält einen von',
                    contains: 'Enthält',
                    startsWith: 'Beginnt mit',
                    endsWith: 'Endet mit',
                    before: 'Ist vor',
                    beforeAt: 'Ist vor oder am',
                    after: 'Ist nach',
                    afterAt: 'Ist nach oder am',
                    isToday: 'Ist heute',
                    // -- negation
                    not: {
                        eq: 'Ist ungleich',
                        isSet: 'Hat keinen Wert',
                        lt: 'Ist nicht kleiner als',
                        lte: 'Ist nicht kleiner oder gleich',
                        gt: 'Ist nicht größer als',
                        gte: 'Ist nicht größer oder gleich',
                        includes: 'Enthält keinen von',
                        contains: 'Enthält nicht',
                        startsWith: 'Beginnt nicht mit',
                        endsWith: 'Endet nicht mit',
                        before: 'Ist nicht vor',
                        beforeAt: 'Ist nicht vor oder am',
                        after: 'Ist nicht nach',
                        afterAt: 'Ist nicht nach oder am',
                        isToday: 'Ist nicht heute',
                    },
                },
            },
            expressionEditor: {
                callableFunction: {
                    lowercase: {
                        name: 'Kleinbuchstaben',
                        info: 'Wandelt einen Text in Kleinbuchstaben um',
                        params: [{ name: 'Text' }],
                    },
                    uppercase: {
                        name: 'Großbuchstaben',
                        info: 'Wandelt einen Text in Großbuchstaben um',
                        params: [{ name: 'Text' }],
                    },
                    substring: {
                        name: 'Textausschnitt',
                        info: 'Gibt einen Teil eines Texts anhand von Start und Länge zurück',
                        params: [{ name: 'Text' }, { name: 'Start' }, { name: 'Länge' }],
                    },
                    trim: {
                        name: 'Leerzeichen entfernen',
                        info: 'Entfernt führende und nachfolgende Leerzeichen eines Texts',
                        params: [{ name: 'Text' }],
                    },
                    min: {
                        name: 'Kleinere Zahl',
                        info: 'Gibt die kleinere von zwei Zahlen zurück',
                        params: [{ name: 'Erste Zahl' }, { name: 'Zweite Zahl' }],
                    },
                    max: {
                        name: 'Größere Zahl',
                        info: 'Gibt die größere von zwei Zahlen zurück',
                        params: [{ name: 'Erste Zahl' }, { name: 'Zweite Zahl' }],
                    },
                    date: {
                        name: 'Aktuelles Datum',
                        info: 'Gibt das heutige Datum ohne Uhrzeit zurück',
                    },
                    time: {
                        name: 'Aktuelle Zeit',
                        info: 'Gibt das aktuelle Datum inklusive Uhrzeit zurück',
                    },
                    age: {
                        name: 'Alter',
                        info: 'Berechnet das Alter aus einem Geburtsdatum',
                        params: [{ name: 'Geburtsdatum' }],
                    },
                    formatDate: {
                        name: 'Datum/Zeit formatieren',
                        info: 'Formatiert ein Datum oder eine Uhrzeit',
                        params: [
                            { name: 'Datum' },
                            {
                                name: 'Format',
                                options: [
                                    { value: 'date', name: 'Nur Datum' },
                                    { value: 'time', name: 'Nur Uhrzeit' },
                                    { value: 'dateTime', name: 'Datum und Uhrzeit' },
                                    { value: 'day', name: 'Tag im Monat' },
                                    { value: 'weekdayNumber', name: 'Wochentag als Zahl' },
                                    { value: 'weekdayShort', name: 'Wochentag kurz' },
                                    { value: 'weekdayLong', name: 'Wochentag ausgeschrieben' },
                                    { value: 'monthNumber', name: 'Monat als Zahl' },
                                    { value: 'monthShort', name: 'Monat kurz' },
                                    { value: 'monthLong', name: 'Monat ausgeschrieben' },
                                    { value: 'quarterNumber', name: 'Quartal als Zahl' },
                                    { value: 'quarterShort', name: 'Quartal kurz' },
                                    { value: 'quarterLong', name: 'Quartal ausgeschrieben' },
                                    { value: 'year', name: 'Jahr vollständig' },
                                ],
                            },
                        ],
                    },
                },
                chooseExpression: 'Zum Auswählen klicken',
                invalidVariable: 'Ungültige Variable',
                literal: 'Literalwert',
                variable: 'Variable',
                function: 'Funktion',
                stringLiteral: 'Text',
                literalTrue: 'ist gesetzt',
                literalFalse: 'ist nicht gesetzt',
            },
            priceEditor: {
                gross: 'Brutto',
                net: 'Netto',
                price: 'Preis',
                priceNet: 'Nettopreis',
                priceNetInfo: 'Der Preis ist exklusive Steuer',
                priceGross: 'Bruttopreis',
                priceGrossInfo: 'Der Preis ist inklusive Steuer',
                taxCode: 'Steuer',
                account: 'Konto',
                costCenter1: 'Kostenstelle 1',
                costCenter2: 'Kostenstelle 2',
            },
        },
    },
}
